module.exports = __webpack_public_path__ + "static/media/data.527bb5e4.svg";